export const MANAGING_Q_INDICATORS_PERIOD_OPTIONS = [
  "LastPeriodIndicatorId",
  "ValueIndicatorId",
  "GroupIndicatorId",
  "AverageIndicatorId",
  "DifferenceIndicatorId",
  "GroupAverageIndicatorId",
];
